import { campaignsService } from '../_services';
import Vue from 'vue';

export const campaigns = {
  namespaced: true,
  state: {
    all: {},
    past: {},
    dynamics: {},
    dynamicsMarked: [],
    holidays: [],
    invoices: {},
    saved: null,
    serverProcessing: false,
    selectedPage: 1,
  },
  actions: {
    getAll({ commit }) {
      commit('getAllRequest');
      campaignsService.getAll().then(
        response => commit('getAllSuccess', response)
      );
    },
    getDynamics({ commit }) {
      commit('getDynamicsRequest');
      campaignsService.getDynamics().then(
        response => commit('getDynamicsSuccess', response)
      );
    },
    getHolidays({ commit }) {
      console.log('getHolidaysDispatch');
      commit('getHolidaysRequest');
      campaignsService.getHolidays().then(
        response => commit('getHolidaysSuccess', response)
      );
    },
    getInvoices({ commit }) {
      commit('getInvoicesRequest');
      campaignsService.getInvoices().then(
        response => commit('getInvoicesSuccess', response)
      );
    },
    getPast({ commit }) {
      commit('getPastRequest');
      campaignsService.getPast().then(
        response => commit('getPastSuccess', response)
      );
    },
    save({ commit }, data) {
      commit('saveRequest');
      let linksData = data;

      campaignsService.save(linksData).then(
        response => commit('saveSuccess', response.data)
      );
    },
  },
  mutations: {
    getAllRequest(state) {
      state.all = { loading: true };
      state.serverProcessing = true;
      state.isDataLoaded = false;
    },
    addDynamicsMarked(state,item) {
      if (state.dynamicsMarked.indexOf(item)<0) state.dynamicsMarked.push(item);
      console.log('state.dynamicsMarked',state.dynamicsMarked);
    },
    getDynamicsRequest(state) {
      state.dynamics = { loading: true };
    },
    getHolidaysRequest(state) {
      console.log('getHolidaysRequest');
      state.holidays = { loading: true };
    },
    getHolidaysSuccess(state, data) {
      // console.log('getHolidaysSuccess');
      const holidays = data.map(e=>new Date(e).toUTCString());
      // console.log('holidays',holidays);
      Vue.setMomentHolidays(holidays);
      state.holidays = holidays;
    },
    holidayChanged(state,dateInfo) {
      let holidays = state.holidays;
      if (dateInfo.selected) {
        holidays.push(dateInfo.date.toUTCString());
      } else {
        holidays.splice(state.holidays.indexOf(dateInfo.date.toUTCString()),1);
      }
      Vue.setMomentHolidays(holidays);
      state.holidays = holidays;
    },
    getInvoicesRequest(state) {
      state.invoices = { loading: true };
    },
    getInvoicesSuccess(state, data) {
      state.invoices = data;
    },
    getPastRequest(state) {
      state.past = { loading: true };
      state.serverProcessing = true;
      state.isDataLoaded = false;
    },
    setSelectedPage(state, page) {
      state.selectedPage = page;
    },
    getAllSuccess(state, data) {
      if (Array.isArray(data)) {
        state.all = data.filter(e=>!(e.project_end||e.report_sent));
      } else {
        state.all = [];
      }
      state.serverProcessing = false;
      state.isDataLoaded = true;
    },
    getDynamicsSuccess(state, data) {
      state.dynamics = data;
    },
    getPastSuccess(state, data) {
      if (Array.isArray(data)) {
        state.past = data.filter(e=>e.project_end||e.report_sent);
      } else {
        state.past = [];
      }
      state.isDataLoaded = true;
      state.serverProcessing = false;
    },
    getAllFailure(state, error) {
      state.all = { error };
      state.serverProcessing = false;
    },
    saveRequest(state) {
      state.serverProcessing = true;
    },
    updateItem(state, data) {
      let tmpObj = data;
      if (Array.isArray(tmpObj)) {
        tmpObj = tmpObj[tmpObj.length - 1][0];
      }
      console.log('tmpObj', tmpObj);
    },
    saveSuccess(state, data) {
      let updatedData = data;
      if (Array.isArray(updatedData)) {
        updatedData = updatedData[updatedData.length - 1];
      }

      updatedData.map(el => {
        state.all.map(e => {
          if (e.id === el.id) {
            e = Object.assign(e, el);
          }
        });
      });
      state.saved = true;
      state.serverProcessing = false;
    },
    saveResetStatus(state) {
      state.saved = null;
    },
    saveSetStatus(state) {
      state.saved = true;
    },
    saveFailure(state) {
      state.serverProcessing = false;
    },
  },
};
